module.exports = __webpack_public_path__ + "img/ded-stock-5.f89daa4b.png";